module.exports = __webpack_public_path__ + "static/media/Toshko.efc66284.jpg";